// extracted by mini-css-extract-plugin
export default {"main":"pageNotFound_main__xfKVj","h2":"pageNotFound_h2__iH9HH"};